import { useState } from 'react';

import { SHIPMENT_STATUS } from '@/lib/constants';
import { DATA_IMAGES } from '@/lib/constants/styles';
import { ShipmentModel } from '@/lib/models/shipment/types';
import { TimelineItemModel } from '@/lib/models/timeline-item/types';
import { TimelineRange } from '@/types';
import { tv } from '@/utils/styles';

import { TimelineBarMilestone } from '../bar-milestone';
import { TimelineBarSegment } from '../bar-segment';
import { getDaysBetween } from '../utils';

const STRIPED_STYLE = { backgroundImage: `url('${DATA_IMAGES.STRIPED_LIGHT}')`, backgroundSize: '4px' };

export interface TimelineRowProps {
  item: TimelineItemModel;
  range: TimelineRange;
  gridSize: number;
  onClick: (shipment: ShipmentModel) => void;
}

const TimelineRow = ({ item, range, gridSize, onClick }: TimelineRowProps) => {
  const [activeMilestone, setActiveMilestone] = useState(false);
  const { startDate, endDate, segments, milestones, latestMilestone, originalShipment } = item;
  const fromDate = new Date(startDate);
  const toDate = new Date(endDate);
  const daysOffset = getDaysBetween(range.start, fromDate, false);
  const daysLen = getDaysBetween(fromDate, toDate, false);
  const isCompleted = item.status === SHIPMENT_STATUS.COMPLETED;

  const { base, bar, segmentWrapper, milestoneWrapper } = styles({ isCompleted });

  return (
    <button type="button" className={base()} onClick={() => onClick(originalShipment)}>
      <div
        className={bar()}
        style={{ width: `${daysLen * gridSize}px`, left: `${daysOffset * gridSize}px`, ...STRIPED_STYLE }}
      >
        <div className={segmentWrapper()}>
          {segments.map((segment) => (
            <TimelineBarSegment key={segment.id} segment={segment} gridSize={gridSize} />
          ))}
        </div>
        <div className={milestoneWrapper()}>
          {milestones.map((milestone, index) => {
            const isLast = index === milestones.length - 1;
            return (
              <TimelineBarMilestone
                key={milestone.id}
                milestone={milestone}
                latestMilestone={latestMilestone}
                gridSize={gridSize}
                startDate={fromDate}
                isLast={isLast}
                onActive={setActiveMilestone}
                activeMilestone={activeMilestone}
              />
            );
          })}
        </div>
      </div>
    </button>
  );
};

const styles = tv({
  slots: {
    base: 'relative block h-14 w-full text-xs',
    bar: 'absolute top-3.5 h-8 rounded-lg border border-grey-300 bg-grey-300/70',
    segmentWrapper: 'absolute bottom-0 left-0 right-0 top-0 flex items-center',
    milestoneWrapper: 'absolute bottom-0 left-0 top-0',
  },
  variants: {
    isCompleted: {
      true: {
        bar: '',
      },
      false: '',
    },
  },
});

export { TimelineRow };
